export default {"src":"/_next/static/media/international.fe99bf35.svg","height":78,"width":132};